import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.Tarifa;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        DescuentoFlete: validation.required,
        Nombre: validation.required,
        IdMatrizTarifa: validation.required

    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class TarifaFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, validar);
    hasError = createSelectorRx(this.errors, err => validation.hasError(err));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;
        const hasError = this.hasError(this.props);

        const Text = getField(kea.Text);
        const Number = getField(kea.Number);
        const Tarifa = getField(selectores.MatrizTarifa);
        return (
            <div>
                <kea.Title titulo="Tarifa" onRegresar={() => history.go("/catalogos/Tarifa")} />
                {kea.autogrid(6, [
                    <Text field="Nombre" label="Nombre" />,
                    <Number field="DescuentoFlete" format="percentage" label="Descuento del flete" />,
                    <Tarifa field="IdMatrizTarifa" label="Matriz de tarifas" />
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const TarifaForm = componentToRx(TarifaFormNoRx);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifas/edit/form.tsx